/**
 * Route copy for `src/routes/portal` (keys: `routes.portal.<file>.<key>`).
 *
 * `fr` is the source; `en` and `ar` are typed against it, so a missing or extra
 * key fails `tsc` (and parity.test.ts). Keys are referenced from the route files
 * through `t()` / `tr()` — edit values freely, never rename a key without its call site.
 *
 * Locale file: en (typed against ./fr). One file per locale so
 * every non-default locale is a separate, lazily-loaded chunk.
 */

import type { Catalog } from './fr';

const en: Catalog = {
  clientPortalPage: {
    pending: 'Pending',
    approved: 'Approved',
    changesRequested: 'Changes requested',
    published: 'Published',
    invalidApprovalLink: 'Invalid approval link.',
    couldNotLoadThisPortal: 'Could not load this portal.',
    reviewBrandname: 'Review — {{brandName}}',
    clientApprovalPortal: 'Client approval portal',
    loading: 'Loading…',
    invalidOrExpiredLink: 'Invalid or expired link',
    thisLinkIsNoLongerValid: 'This link is no longer valid. Ask the person who sent it to you for a new one.',
    couldNotDisplayThisPortal: 'Could not display this portal',
    helloName: 'Hello {{name}}, ',
    item: 'item',
    toReview: 'to review.',
    display: 'Display',
    list: 'List',
    calendar: 'Calendar',
    noItemAwaitingYourReviewFor: 'No item awaiting your review for now.',
    youAreReviewingThisContentThrough: 'You are reviewing this content through a personal, secure link. No account required.',
    unscheduled: 'Unscheduled',
    explainTheChangesYouWant: 'Explain the changes you want.',
    approvedThankYou: 'Approved — thank you!',
    changeRequestSent: 'Change request sent.',
    theActionFailedTryAgain: 'The action failed. Try again.',
    commentSent: 'Comment sent.',
    sendingTheCommentFailed: 'Sending the comment failed.',
    contentToReview: 'Content to review',
    you: 'You',
    team: 'Team',
    aCommentOrTheChangesYou: 'A comment or the changes you want…',
    approving: 'Approving…',
    approve: 'Approve',
    sending: 'Sending…',
    requestChanges: 'Request changes',
    comment: 'Comment',
    you2: 'You',
    approved2: 'approved',
    requestedChangesFor: 'requested changes for',
    thisItem: 'this item.',
  },
};

export default en;
